var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"wzc_option",class:_vm.sizeSliderCurrent==_vm.label?'wzc_option_select':'',style:(_vm.styleVar),on:{"click":_vm.currentSelect}},[_c('div',{staticClass:"wzc_option_dropdown_item"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }